<template>
  <BaseLink
    :aria-label="ariaLabel"
    :colorless="colorless"
    :href="relativeHref"
    :tap-area-expansion="tapAreaExpansion"
    class="bh-link"
    @click="onClick"
  >
    <slot />
  </BaseLink>
</template>

<script lang="ts">
  import BaseLink from '@devhacker/shared/components/base/BaseLink.vue';
  import { removeBurninghutFromUrl } from '~/utils/link';

  export default defineNuxtComponent({
    name: 'BHLink',

    components: {
      BaseLink,
    },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },

      // Контекст события для аналитики
      // Место в котором расположен виджет\элемент
      area: {
        default() {
          return () => '';
        },
      },

      // Контекст события для аналитики
      // Название действия для аналитики
      eventAction: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      href: {
        type: String,
        default: '#',
      },

      ariaLabel: {
        type: String,
        default: undefined,
      },

      tapAreaExpansion: {
        type: String,
        default: undefined,
      },

      colorless: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['click'],

    computed: {
      relativeHref() {
        return removeBurninghutFromUrl(this.href);
      },
    },

    methods: {
      onClick() {
        this.$emit('click');

        // Костыль для отправки аналитики
        // для серого блока
        // @ts-expect-error injected functions are not typed in options API
        const area = this.area();
        // @ts-expect-error injected functions are not typed in options API
        const eventAction = this.eventAction();

        const sendAnalyticsAreas = [
          'home',
          'above-comments',
          'below-comments',
          'after-first-paragraph',
          'post-dynamic',
        ];
        const eventActionsToSend = ['Серый блок'];

        if (sendAnalyticsAreas.includes(area) && eventActionsToSend.includes(eventAction)) {
          // Функция для аналитики клика на серый блок
          // const slugReferrer = getSlugFromUrl(this.href);
        }
      },
    },
  });
</script>
